/**
 * AuthorityOverlayState — module singleton holding the "show full-scene
 * authority overlay" toggle. Same React→Phaser bridge pattern as
 * CastStripState — UIContext writes via a small effect, PlayerRenderer
 * + MobRenderer read each frame.
 *
 * Why not use UIContext directly: Phaser renderers run outside React
 * (tied to the Phaser game loop), so they can't subscribe to React
 * context. A module-singleton + per-frame poll is the cheapest bridge.
 */

let enabled = false;

export function setAuthorityOverlayEnabled(value: boolean): void {
  enabled = value;
}

export function isAuthorityOverlayEnabled(): boolean {
  return enabled;
}
